<template>
  <div class="flex items-center" v-if="numberOfSlides > 5">
    <span
      v-for="n in 5"
      class="dot"
      :class="{
        'active-dot': activeDot(n - 1, currentPage, numberOfSlides),
      }"
    ></span>
  </div>
  <div class="flex items-center" v-else>
    <span
      v-for="n in numberOfSlides"
      class="dot"
      :class="{
        'active-dot': n - 1 === currentPage,
      }"
    ></span>
  </div>
</template>

<script>

export default {
  props: {
    numberOfSlides: {
      type: Number,
      default: 0,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    }
  },
  methods: {
    activeDot(indexDot, currentPage, totalImages) {
      if (
        ((indexDot === 0 || indexDot === 1) && indexDot === currentPage) ||
        (indexDot === 3 && totalImages - 2 === currentPage) ||
        (indexDot === 4 && totalImages - 1 === currentPage) ||
        (indexDot === 2 &&
          currentPage !== 0 &&
          currentPage !== 1 &&
          currentPage !== totalImages - 2 &&
          currentPage !== totalImages - 1)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.dot {
  background: white;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  opacity: 0.6;
  transition: 0.3s;
}

.active-dot {
  background: white !important;
  opacity: 1;
  height: 14px;
  width: 14px;
}

.carousel-dots{
  bottom: 24px !important;
}
</style>
